<s1-input-select class="col-6 mb-2 fix-margin"
                 [control]="control"
                 [itemsList]="options"
                 [bindAllObject]="bindAllObject"
                 [label]="label"
                 [labelGrouped]="false"
                 (onSelectClear)="cleared()"
                 (onSelectChange)="changed($event)"
></s1-input-select>
